<template>
  <div class="auth-wrapper auth-v1">
    <div class="auth-inner">
      <v-card class="auth-card">
        <!-- logo -->
        <v-card-title class="d-flex align-center justify-center py-7">
          <router-link
            to="/"
            class="d-flex align-center"
          >
            <v-img
              :src="appLogo"
              max-height="30px"
              max-width="30px"
              alt="logo"
              contain
              class="me-3 "
            ></v-img>

            <h2 class="text-2xl font-weight-semibold">
              {{ appName }}
            </h2>
          </router-link>
        </v-card-title>

        <!-- title -->
        <v-card-text>
          <p class="text-2xl mb-5 font-weight-semibold text-center text--primary mb-2">
            👋🏻  مرحبا بك
          </p>
          <p class="mb-2 text-center">
            الرجاء تسجيل الدخول إلى حسابك وبدء العمل
          </p>
        </v-card-text>

        <!-- two factor code, asked after the password was accepted -->
        <v-card-text v-if="totpChallenge">
          <p class="text-sm mb-4 text-center">
            {{ useRecoveryCode ? 'ادخل احد رموز الاسترداد.' : 'ادخل الرمز الظاهر في تطبيق المصادقة.' }}
          </p>

          <otp-input
            v-if="!useRecoveryCode"
            ref="otp"
            v-model="totpCode"
            :length="6"
            :disabled="loadingSubmit"
            autofocus
            class="mb-6"
            @complete="submitTotp()"
          />

          <v-text-field
            v-else
            v-model="totpCode"
            outlined
            label="رمز الاسترداد"
            placeholder="xxxxxxxx-xxxxxxxx"
            autocomplete="one-time-code"
            autofocus
            @keyup.enter="submitTotp"
          ></v-text-field>

          <v-btn
            block
            color="primary"
            class="mt-2"
            :disabled="loadingSubmit || !canSubmitTotp"
            :loading="loadingSubmit"
            @click="submitTotp()"
          >
            تأكيد
          </v-btn>
          <v-btn
            block
            text
            small
            class="mt-2"
            @click="toggleRecoveryCode()"
          >
            {{ useRecoveryCode ? 'استخدام رمز التطبيق' : 'استخدام رمز استرداد' }}
          </v-btn>
          <v-btn
            block
            text
            small
            @click="cancelTotp()"
          >
            رجوع
          </v-btn>
        </v-card-text>

        <!-- login form -->
        <v-card-text v-else>
          <v-form
            ref="form"
            v-model="valid"
          >
            <v-text-field
              v-model="email"
              v-max-length="200"
              :rules="emailRules"
              outlined
              label="البريد الالكتروني"
              placeholder="email@example.com"
              hide-details
              autocomplete="off"
              required
              class="mb-3"
            ></v-text-field>

            <v-text-field
              v-model="password"
              v-max-length="200"
              :rules="passwordRules"
              outlined
              :type="isPasswordVisible ? 'text' : 'password'"
              label="كلمة المرور"
              autocomplete="off"
              required
              placeholder="············"
              :append-icon="isPasswordVisible ? icons.mdiEyeOffOutline : icons.mdiEyeOutline"
              hide-details
              @keyup.enter="submitLogin"
              @click:append="isPasswordVisible = !isPasswordVisible"
            >
            </v-text-field>

            <div class="d-flex align-center justify-space-between flex-wrap">
              <v-checkbox
                label="تذكرني"
                hide-details
                class="me-3 mt-1"
              >
              </v-checkbox>
            </div>

            <v-btn
              block
              color="primary"
              class="mt-6"
              :disabled="!valid || loadingSubmit"
              :loading="loadingSubmit"
              @click="submitLogin()"
            >
              دخول
            </v-btn>
          </v-form>
        </v-card-text>

        <!-- Activator -->

        <!-- divider -->
        <v-card-text class="d-flex align-center mt-2">
          <v-divider></v-divider>
          <span class="mx-5">  مركز الكفيل لتقنية المعلومات </span>
          <v-divider></v-divider>
        </v-card-text>
      </v-card>
    </div>
    <!-- background triangle shape  -->
    <img
      class="auth-mask-bg"
      height="173"
      :src="require(`@/assets/images/misc/mask-${$vuetify.theme.dark ? 'dark':'light'}.png`)"
      alt="auth-mask-bg"
    />
  </div>
</template>

<script>
// eslint-disable-next-line object-curly-newline
import { mdiEyeOutline, mdiEyeOffOutline } from '@mdi/js'
import { ref } from '@vue/composition-api'
import themeConfig from '@themeConfig'
import axios from '@axios'

import toast from '@/store/toast'
import auth from '@/store/auth'
import router from '@/router/index'
import OtpInput from '@/components/OtpInput.vue'

export default {
  components: { OtpInput },

  setup() {
    const isPasswordVisible = ref(false)
    const email = ref('')
    const password = ref('')

    // const socialLink = [
    //   {
    //     icon: mdiFacebook,
    //     color: '#4267b2',
    //     colorInDark: '#4267b2',
    //   },
    //   {
    //     icon: mdiTwitter,
    //     color: '#1da1f2',
    //     colorInDark: '#1da1f2',
    //   },
    //   {
    //     icon: mdiGithub,
    //     color: '#272727',
    //     colorInDark: '#fff',
    //   },
    //   {
    //     icon: mdiGoogle,
    //     color: '#db4437',
    //     colorInDark: '#db4437',
    //   },
    // ]
    return {
      isPasswordVisible,
      email,
      password,

      // socialLink,

      // themeConfig
      appName: themeConfig.app.name,
      appLogo: themeConfig.app.logo,

      icons: {
        mdiEyeOutline,
        mdiEyeOffOutline,
      },
    }
  },
  data: () => ({
    valid: true,
    loadingSubmit: false,
    password: '',
    passwordRules: [
      v => !!v || 'Password is required',
    ],
    email: '',
    emailRules: [
      v => !!v || 'E-mail is required',
      v => /.+@.+/.test(v) || 'E-mail must be valid',
    ],
    totpChallenge: null,
    totpCode: '',
    useRecoveryCode: false,

  }),
  computed: {
    canSubmitTotp() {
      return this.useRecoveryCode ? this.totpCode.trim().length > 0 : this.totpCode.length === 6
    },
  },
  mounted() {
  },
  methods: {
    async submitLogin() {
      if (this.$refs.form.validate() === false) {
        return
      }
      const userData = {
        email: this.email,
        password: this.password,
      }
      this.loadingSubmit = true;
      try {
        const response = await axios.post('/auth/login', userData)
        const ResSuccess = response.data.success
        if (ResSuccess === true) {
          // account has an authenticator app enrolled: ask for the code before
          // anything is stored, the response carries no token yet
          if (response.data.data.totp_challenge) {
            this.totpChallenge = response.data.data.challenge_token
            this.totpCode = ''

            return
          }
          await this.completeLogin(response.data.data)
        }
      } catch (error) {
        // await toast.dispatch('error', error.response ? error.response.data.message : error.message)
      } finally {
        this.loadingSubmit = false;
      }
    },

    async submitTotp() {
      // the boxes submit on their own once full, so a click landing at the same
      // moment must not fire a second request
      if (this.loadingSubmit || !this.canSubmitTotp) {
        return
      }
      this.loadingSubmit = true;
      try {
        const response = await axios.post('/auth/login/totp', {
          challenge_token: this.totpChallenge,
          code: this.totpCode,
        })
        if (response.data.success === true) {
          await this.completeLogin(response.data.data)
        }
      } catch (error) {
        // an expired challenge (419) means starting over from the password
        if (error.response && error.response.status === 419) {
          this.cancelTotp()
        }
        this.totpCode = ''
        if (this.$refs.otp) {
          this.$refs.otp.clear()
        }
      } finally {
        this.loadingSubmit = false;
      }
    },

    toggleRecoveryCode() {
      this.useRecoveryCode = !this.useRecoveryCode
      this.totpCode = ''
    },

    cancelTotp() {
      this.totpChallenge = null
      this.totpCode = ''
      this.useRecoveryCode = false
      this.password = ''
    },

    async completeLogin(user) {
      await auth.commit('SET_USER', user)

      // two factor is required and this account has not enrolled: the dashboard
      // stays out of reach until the setup page is done with them.
      // Loaded as a fresh page rather than pushed: the app's route transition
      // (scroll-x-transition) never finishes when both routes use the blank
      // layout, which leaves this login form on screen forever.
      if (user.totp && user.totp.must_setup) {
        window.location.assign(router.resolve({ name: 'totp-setup' }).href)

        return
      }
      await router.push('/home');
      await toast.dispatch('success', 'تم تسجيل الدخول بنجاح ')
    },

  },

}
</script>

<style lang="scss">
@import '@core/preset/preset/pages/auth.scss';
</style>
